import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Field } from '../Field';
import { FormItem } from './FormItem';
import { VFFieldProps } from '../types';
import { DATA_FORM_INPUT } from '../../common/data';
import { Wysiwyg as WysiwygInput } from '../../wysiwyg/Wysiwyg';

export type WysiwygProps = VFFieldProps<
  React.ComponentProps<typeof WysiwygInput>
>;
export const Wysiwyg = React.forwardRef<HTMLDivElement, WysiwygProps>(
  (
    {
      name,
      validate,
      className,
      inputClassName,
      inlineValidation,
      contentClassName,
      label,
      onChange: customOnChange,
      required,
      disabled,
      validateWarning,
      ...other
    },
    ref
  ) => {
    return (
      <FormItem
        name={name}
        inlineValidation={inlineValidation}
        className={className}
        label={label}
        required={required}
        disabled={disabled}
        validateWarning={validateWarning}
        contentClassName={contentClassName}
      >
        <Field name={name} validate={validate}>
          {({
            input: { value, onChange, name, ...nother },
            meta,
          }: FieldRenderProps<string>) => {
            const handleChange = React.useCallback(
              (value: any) => {
                let realVal: string | undefined = value;
                if (realVal === '') {
                  realVal = undefined;
                }
                const rv = { target: { name, value: realVal } };
                customOnChange ? customOnChange(realVal as any) : onChange?.(rv);
              },
              [customOnChange, onChange, name]
            );
            return (
              <WysiwygInput
                {...DATA_FORM_INPUT(name)}
                className={inputClassName}
                // @ts-ignore
                ref={ref}
                {...nother}
                {...other}
                disabled={disabled || meta.submitting}
                onChange={handleChange}
                value={value}
              />
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
